/* Le mascherine del periodo: un tocco per l'anno, un semestre, un trimestre o l'anno a cavallo.
 *
 * Nato il 17 ottobre 2026 per la scheda Periodo e usato anche da Gestione, cosi' il periodo si sceglie
 * nello stesso modo dappertutto. Le date esatte stanno sempre sotto i bottoni: chi guarda un numero
 * sa quali giorni contiene senza doverli indovinare dal nome. Le date a mano servono ai casi strani
 * (una chiusura a meta' mese) e si accettano solo se la prima non viene dopo la seconda.
 */

import { useId } from "react";
import {
  estremi,
  intervalloValido,
  MASCHERINE,
  nomePeriodo,
  selezione,
  type FormaPeriodo,
  type Selezione,
} from "../periodi";

export function SelettorePeriodo({
  valore,
  anni,
  cambia,
}: {
  valore: Selezione;
  /** Gli anni da offrire, dal piu' recente. L'anno scelto c'e' sempre, anche se non e' in elenco. */
  anni: number[];
  cambia: (s: Selezione) => void;
}) {
  const id = useId();
  const libero = valore.forma === "libero";
  const elenco = anni.includes(valore.anno) ? anni : [...anni, valore.anno].sort((a, b) => b - a);

  function cambiaData(campo: "dal" | "al", testo: string) {
    if (!testo) return;
    const nuovo: Selezione = campo === "dal" ? { ...valore, dal: testo } : { ...valore, al: testo };
    if (intervalloValido(nuovo)) cambia(nuovo);
  }

  return (
    <div className="selettore-periodo">
      <div className="segmenti" role="group" aria-label="Periodo">
        {MASCHERINE.map((m) => (
          <button
            key={m.forma}
            type="button"
            aria-pressed={valore.forma === m.forma}
            onClick={() => cambia(selezione(m.forma, valore.anno))}
          >
            {m.nome}
          </button>
        ))}
        <button type="button" aria-pressed={libero} onClick={() => cambia({ ...valore, forma: "libero" })}>
          Date a scelta
        </button>
      </div>
      <div className="periodo-riga">
        {libero ? (
          <div className="filtri-date">
            <label>
              dal
              <input
                type="date"
                value={valore.dal}
                max={valore.al}
                onChange={(e) => cambiaData("dal", e.target.value)}
              />
            </label>
            <label>
              al
              <input
                type="date"
                value={valore.al}
                min={valore.dal}
                onChange={(e) => cambiaData("al", e.target.value)}
              />
            </label>
          </div>
        ) : (
          <div className="campo-scelta campo-anno-periodo">
            <label htmlFor={`${id}-anno`}>{valore.forma === "cavallo" ? "Anno di inizio" : "Anno"}</label>
            <select
              id={`${id}-anno`}
              value={valore.anno}
              onChange={(e) => cambia(selezione(valore.forma as Exclude<FormaPeriodo, "libero">, Number(e.target.value)))}
            >
              {elenco.map((a) => (
                <option key={a} value={a}>
                  {a}
                </option>
              ))}
            </select>
          </div>
        )}
        <p className="aiuto periodo-estremi">
          <strong>{nomePeriodo(valore)}</strong>, {estremi(valore)}
        </p>
      </div>
    </div>
  );
}
